import React from 'react';
import { View, Text } from 'react-native';
import { SectionCardProps } from './SectionCard.types';
import styles from './SectionCard.styles';

/**
 * SectionCard
 *
 * Shared shell for the People Hub activity sections (Coaching History, New Action,
 * Balanced Feedback, Final Signatures, …): a light-blue header band with a title on
 * the left and a subtitle/badge on the right, sitting above a white body that holds
 * whatever content the caller renders.
 */
const SectionCard: React.FC<SectionCardProps> = ({ title, description, subtitle, children, bodyStyle }) => (
  <View style={styles.card}>
    <View style={styles.header}>
      <View style={styles.titleBlock}>
        <Text style={styles.title}>{title}</Text>
        {typeof description === 'string' ? <Text style={styles.description}>{description}</Text> : description}
      </View>
      {typeof subtitle === 'string' ? <Text style={styles.subtitle}>{subtitle}</Text> : subtitle}
    </View>
    <View style={[styles.body, bodyStyle]}>{children}</View>
  </View>
);

export default SectionCard;
